import BackendService from "./BackendService";
import { API_PATH, STORAGE_KEYS } from "../const";
import { clearAllIndexedDB } from "helpers/AppSettingsHelper";

async function login(username, password) {
  const reqData = { username, password };
  try {
    const resp = await BackendService.postData("/login/", reqData, {
      "User-Interface": "ios",
    });
    if (!resp.token) {
      return new Error("Failed generate auth token from server");
    }
    localStorage.setItem(STORAGE_KEYS.USER_AUTH_TOKEN, resp.token);
  } catch (error) {
    return error;
  }
}

async function logout() {
  try {
    await BackendService.destroy(API_PATH.LOGOUT, null, {});
  } catch (error) {
    console.error(error);
  }

  localStorage.clear();

  try {
    await clearAllIndexedDB();
  } catch (error) {
    console.error("Error clearing IndexedDB on logout:", error);
  }
}
async function resetPassword(data) {
  return BackendService.postData("/resetpassword/", data);
}
async function createAccount(data) {
  return BackendService.postData("/register/", data);
}

const findCountryCode = () => {
  return BackendService.getData("/public/country-code/");
};

const AuthService = {
  login,
  logout,
  resetPassword,
  createAccount,
  findCountryCode,
};

export default AuthService;
